import { session1 } from './session1';
import { session2 } from './session2';
import { session3 } from './session3';
import { session4 } from './session4';
import { session5 } from './session5';
import { session6 } from './session6';
import { session7 } from './session7';
import { session8 } from './session8';
import { session9 } from './session9';
import { session10 } from './session10';
import { completion } from './completion.js';

export const electricalBasics = {
  id: "electrical-basics",
  title: "Electrical Basics",
  description: "Learn the fundamentals of electricity from atoms to circuits",
  color: "#FF6B6B",
  icon: "⚡",
  level: "Beginner",
  duration: "5 hours",
  students: "2,340",
  sessions: [
    session1,
    session2,
    session3,
    session4,
    session5,
    session6,
    session7,
    session8,
    session9,
    session10,
    completion 
  ]
};
